import { createContext } from 'react';

type ExtraSettings = { hubMode: boolean };
export type SettingsContextValue = typeof window.settings & ExtraSettings;

export const SettingsContext = createContext<SettingsContextValue>({
  ...window.settings,
  hubMode: false,
});
